import api from './api';

const ManagerService = {
  createManager: async (data) => {
    try {
      const response = await api.post('/users/create-manager/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  setPassword: async (data) => {
    try {
      const response = await api.post('/set-password/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default ManagerService;
